import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect } from 'react';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';

import Typography from '@material-ui/core/Typography';
import { Container } from '@material-ui/core';
import ReactFontLoader from 'react-font-loader';

import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useDispatch, useSelector } from 'react-redux';
import Loading from "./loading"
import {getClients} from '../actions/clients';

const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      overflow: 'hidden',
      marginTop:'4vh',
      marginBottom:'3vh',
      
      backgroundColor: theme.palette.background.paper,
    },
    gridList: {
      width: '120vh'   ,
      height: '70vh',
      overflowY:'scroll',
      scrollbarWidth:'auto'
      
    },
    icon: {
      color: 'rgba(255, 255, 255, 0.54)',
    },
  }));
  

const Clientele = ({clientlist}) => {
  
  const dispatch = useDispatch();

  useEffect(()=>{
    dispatch(getClients())
  })
  const clients = useSelector(state => state.clients)
    const classes = useStyles();

    const matches = useMediaQuery('(min-width:650px)');


    return ( 
        <Container >
            <ReactFontLoader url='https://fonts.googleapis.com/css2?family=Rubik:wght@400;500;600&display=swap' />
            <Typography variant='h4' style={{fontFamily:'Rubik',marginTop:'4vh',marginLeft:'4vw',fontWeight:'500',color:'#0a3668'}}>Our Clients</Typography>
        
        <div className={clients.length?classes.root:{display:'flex',
      justifyContent:'center',
      alignItems:'center',
      flexDirection:'column',
      fontFamily:'Rubik',
      }}>
          {clients.length?<></>:<div >
            <Loading height={'70vh'}></Loading>
          </div>}
      <GridList cellHeight={160} className={classes.gridList} cols={matches?3:2}>
        {clients.map((tile,i) => (
          <GridListTile key={i} cols={1}>
            <img width='100%' height='100%' src={tile.selectedFile} alt={tile.name} />
            <GridListTileBar style={{background:'rgba(13,38,69,0.9)',fontFamily:'Rubik'}}
              title={tile.name}
              
            />
          </GridListTile>
        ))}
      </GridList>
    </div>
    </Container>
     );
}
 
export default Clientele;